import React from "react";

import { Safearea } from "../components/UI/Safearea/Safearea";
import { Portfolio } from "../components/Portfolio/Portfolio";
import { Header } from "../components/Layout/Header/Header";

export const PortfolioPage = () => (
  <React.Fragment>
    <Header title="Portafolio" />
    <Safearea>
      <Portfolio />
    </Safearea>
  </React.Fragment>
);
